const skillsData = [
  {
    type: "Frontend",
    skill: "Bootstrap",
  },
  {
    type: "Frontend",
    skill: "CSS",
  },
  {
    type: "Backend",
    skill: "Express",
  },
  {
    type: "Design",
    skill: "Figma",
  },
  {
    type: "Frontend",
    skill: "HTML",
  },
  {
    type: "Frontend",
    skill: "JavaScript",
  },
  {
    type: "Backend",
    skill: "Node.js",
  },
  {
    type: "Backend",
    skill: "PostgreSQL",
  },
  {
    type: "Backend",
    skill: "Process Optimization",
  },
  {
    type: "Personal",
    skill: "Project Management",
  },
  {
    type: "Frontend",
    skill: "React",
  },
  {
    type: "Frontend",
    skill: "React Native",
  },
  {
    type: "Backend",
    skill: "RESTful APIs",
  },
  {
    type: "Frontend",
    skill: "Tailwind CSS",
  },
  {
    type: "Frontend",
    skill: "WordPress",
  },
];

export default skillsData;
